import { useEffect, useState } from "react";

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean | null>(null);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const checkIsMobile = () => {
                setIsMobile(window.innerWidth <= 768);
            };

            // Initial check
            checkIsMobile();

            // Add event listener to check on resize
            window.addEventListener("resize", checkIsMobile, { passive: true });

            // Clean up event listener on component unmount
            return () => {
                window.removeEventListener("resize", checkIsMobile);
            };
        }
    }, []);

    return isMobile;
};

export default useIsMobile;
